import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConciliacaoMovimento } from 'src/app/financeiro/shared/conciliacao-movimento.model';
import { CaixaService } from 'src/app/financeiro/shared/caixa.service';
import { ContaCorrenteService } from 'src/app/conta-corrente/shared/conta-corrente.service';
import { DadoBancarioService } from 'src/app/dado-bancario/shared/dado-bancario.service';
import { CaixaMovimentoService } from 'src/app/financeiro/shared/caixa-movimento.service';
import { ConciliacaoMovimentoEntidadeService } from 'src/app/financeiro/shared/conciliacao-movimento-entidade.service';
import { ContaPesquisa } from 'src/app/financeiro/shared/conta-pesquisa.model';

export interface DialogData {
  caixaId: number;
}

@Component({
  selector: 'app-conciliacao-dialog',
  templateUrl: 'conciliacao-dialog.component.html',
  styleUrls: ['conciliacao-dialog.component.css']
})
export class ConciliacaoDialogComponent {
  conciliacao: ConciliacaoMovimento | null = null;
  arquivoSelecionado: File | null = null;
  nomeArquivo: string | null = null;
  maximizado: boolean = false;
  pesquisaContas = new ContaPesquisa();

  constructor(
    private _snackBar: MatSnackBar,
    private caixaService: CaixaService,
    private caixaMovimentoService: CaixaMovimentoService,
    private conciliacaoMovimentoEntidadeService: ConciliacaoMovimentoEntidadeService,
    private contaCorrenteService: ContaCorrenteService,
    private bancoService: DadoBancarioService,
    @Inject(MAT_DIALOG_DATA) public ICaixa: DialogData,
    public dialogRef: MatDialogRef<ConciliacaoDialogComponent>) {}

    selecionarArquivo(event: Event) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        this.arquivoSelecionado = input.files[0];
        this.nomeArquivo = this.arquivoSelecionado.name;
      }


  }

  fechar(): void {
    this.dialogRef.close();
  }

  async confirmar(): Promise<void> {
    if (this.arquivoSelecionado) {
      //Salvar Model de conciliação e chamando endpoint passando os dados

      try {
        // Ler o conteúdo do arquivo .osx
        const conciliacao = await this.parseOFXFile(this.arquivoSelecionado);

        // Enviar dados para o endpoint
        this.pesquisaContas.grupoContaId = null;
        this.conciliacaoMovimentoEntidadeService.postSalvarConciliacao(conciliacao, this.pesquisaContas).subscribe(result => {
          this._snackBar.open('📝 Registro Salvo com Sucesso! ', '✖', {
            duration: 7000, panelClass: ['mat-toolbar', 'succes']
          });
          // Fechar o diálogo passando os dados do arquivo
          this.dialogRef.close(this.arquivoSelecionado);
        })

      } catch (error) {
        console.error("Erro ao processar o arquivo ou ao salvar a conciliação:", error);
      }
    }
  }

  fecharDialog() {
    this.dialogRef.close();
  }

  maximizarDialog() {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog() {

    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('100%', '100%');
    }
    else {
      this.dialogRef.updateSize('40%', '35%');
    }
    this.maximizado = false;
  }

  parseOFXFile(file: File): Promise<ConciliacaoMovimento[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Evento para lidar com a leitura bem-sucedida do arquivo
      reader.onload = () => {
        const ofxContent = reader.result as string;
        try {
          const conciliacao = this.parseOFX(ofxContent);
          resolve(conciliacao);
        } catch (error) {
          reject(`Erro ao processar o arquivo OFX: ${error}`);
        }
      };

      // Evento para lidar com erros na leitura do arquivo
      reader.onerror = () => {
        reject(`Erro ao ler o arquivo: ${reader.error}`);
      };

      // Ler o arquivo como texto
      reader.readAsText(file);
    });
  }

  // Função parseOFX (mesma lógica anterior)
  async parseOFX(ofxContent: string): Promise<ConciliacaoMovimento[]> {
    try {
      if (!ofxContent || typeof ofxContent !== 'string') {
        throw new Error('Conteúdo do OFX inválido ou vazio.');
      }

      // const conciliacao = new Conciliacao();
      let listaconciliacao = [];
      // Extrair dados bancários
      const codigoBanco = parseInt(this.extractTagValue(ofxContent, 'BANKID') || '0');
      const agencia = this.extractTagValue(ofxContent, 'BRANCHID') || '';
      const contaCorrente = this.extractTagValue(ofxContent, 'ACCTID') || '';

      await this.validaOFX(codigoBanco, agencia, contaCorrente);

      this.pesquisaContas.dataInicial = this.parseOFXDate(this.extractTagValue(ofxContent, 'DTSTART') || '');
      this.pesquisaContas.dataFinal = this.parseOFXDate(this.extractTagValue(ofxContent, 'DTEND') || '');
      console.log(this.pesquisaContas.dataInicial);
      console.log(this.pesquisaContas.dataFinal);


      // Extrair transações
      const transacaoMatches = ofxContent.match(/<STMTTRN>[\s\S]*?<\/STMTTRN>/g) || [];
      listaconciliacao = transacaoMatches.map((transacao) => {
        const conciliacao = new ConciliacaoMovimento();
        conciliacao.tipo = this.extractTagValue(transacao, 'TRNTYPE');
        conciliacao.dataPostagem = this.parseOFXDate(this.extractTagValue(transacao, 'DTPOSTED') || '');
        conciliacao.valor = parseFloat(this.extractTagValue(transacao, 'TRNAMT').replace(',','.') || '0');
        conciliacao.fitid = this.extractTagValue(transacao, 'FITID') || '';
        conciliacao.nome = this.extractTagValue(transacao, 'NAME') || '';
        conciliacao.descricao = this.extractTagValue(transacao, 'MEMO') || '';
        conciliacao.caixaId = this.ICaixa.caixaId;
        conciliacao.codigoBancoOFX = codigoBanco;
        conciliacao.agenciaOFX = agencia;
        conciliacao.contaCorrenteOFX = contaCorrente;

        return conciliacao;
      });

      // Ordena pela dataPostagem (do mais antigo para o mais recente)
      listaconciliacao.sort((a, b) => {
        return a.dataPostagem.getTime() - b.dataPostagem.getTime();
      });

      return listaconciliacao;
    } catch (error) {
      console.error('Erro ao analisar o conteúdo do OFX:', error);
      throw error;
    }
  }

  // Funções auxiliares
  extractTagValue(content: string, tag: string): string | null {
    const regex = new RegExp(`<${tag}>(.*?)<\/${tag}>|<${tag}>([^<]*)`.replace(/(\r\n|\n|\r)/gm, ""), 's');
    const match = content.match(regex);
    if (match) {
      return (match[1] || match[2] || '').replace(/\n/g, '').trim(); // Remove \n e espaços
    }
  }

  parseOFXDate(ofxDate: string): Date {
    const year = parseInt(ofxDate.substring(0, 4), 10);
    const month = parseInt(ofxDate.substring(4, 6), 10) - 1; // Mês começa em 0
    const day = parseInt(ofxDate.substring(6, 8), 10);
    const hour = parseInt(ofxDate.substring(8, 10) || '0', 10);
    const minute = parseInt(ofxDate.substring(10, 12) || '0', 10);
    const second = parseInt(ofxDate.substring(12, 14) || '0', 10);

    return new Date(year, month, day, hour, minute, second);
  }

  validaOFX(bancoOFX, agenciaOFX, contaCorrenteOFX): Promise<void> {
    return new Promise((resolve, reject) => {
      this.caixaService.getCaixa(this.ICaixa.caixaId).subscribe(data => {
        const contaCorrenteId = data.body.contaCorrenteId;

        this.contaCorrenteService.getContaCorrente(contaCorrenteId).subscribe(contaData => {
          let bancoOFXString = bancoOFX.toString();
          let agenciaOFXString = agenciaOFX.toString();
          let contaCorrenteOFXString = contaCorrenteOFX.toString();

          const contaBancoNumero = contaData.body.banco.numero.toString();
          const contaAgencia = contaData.body.agencia.toString();
          const contaNumero = contaData.body.numero.toString();

          //eliminar 0s a esquerda do que vem do ofx
          const bancoOFXFormatado = bancoOFXString.replace(/^0+/, '');
          const agenciaOFXFormatado = agenciaOFXString.replace(/^0+/, '');
          const contaCorrenteOFXFormatado = contaCorrenteOFXString.replace(/^0+/, '');

          //eliminar 0s a esquerda do que vem do banco
          const contaBancoNumeroFormatado = contaBancoNumero.replace(/^0+/, '');
          const contaAgenciaFormatado = contaAgencia.replace(/^0+/, '');
          const contaNumeroFormatado = contaNumero.replace(/^0+/, '');

          // verifica se banco da conta é mesmo do ofx
          if(bancoOFXFormatado !== contaBancoNumeroFormatado){
            this._snackBar.open('😖 Operação não permitida! \n\n Banco presente no arquivo .ofx não é o mesmo Banco desse caixa', '✖', {
              duration: 15000, panelClass: ['mat-toolbar', 'warn']
            });
            reject(new Error('Banco presente no arquivo .ofx não é o mesmo Banco desse caixa'));
            return;
          }

          // Verifica se o numero da conta esta no numero da conta do OFX (pode ser substring)
          if(!contaCorrenteOFXFormatado.includes(contaNumeroFormatado)){
            this._snackBar.open('😖 Operação não permitida! \n\n A Conta Corrente presente no arquivo .ofx não é a mesma Conta Corrente desse Caixa', '✖', {
              duration: 15000, panelClass: ['mat-toolbar', 'warn']
            });
            reject(new Error('A Conta Corrente presente no arquivo .ofx não é a mesma Conta Corrente desse Caixa'));
            return;
          }

          // Se ofx não tinha tag de agencia,
          // verifica primeiros 4 digitos da conta que podem ser a agencia
          if(agenciaOFXFormatado === '' && contaCorrenteOFXFormatado.length > 4){
            const agenciaTemp = contaCorrenteOFXFormatado.substring(0,4);
            if(!agenciaTemp.includes(contaAgenciaFormatado)){
              this._snackBar.open('😖 Operação não permitida! \n\n A Agência presente no arquivo .ofx não é a mesma Agência desse Caixa', '✖', {
                duration: 15000, panelClass: ['mat-toolbar', 'warn']
              });
              reject(new Error('A Agência presente no arquivo .ofx não é a mesma Agência desse Caixa'));
              return;
            }
          } else {
            if(agenciaOFXFormatado !== contaAgenciaFormatado){
              this._snackBar.open('😖 Operação não permitida! \n\n A Agência presente no arquivo .ofx não é a mesma Agência desse Caixa', '✖', {
                duration: 15000, panelClass: ['mat-toolbar', 'warn']
              });
              reject(new Error('A Agência presente no arquivo .ofx não é a mesma Agência desse Caixa'));
              return;
            }
          }


          resolve();
        });
      });
    });

  }

}
